import Copy from './Copy/Copy';
import Delete from './Delete/Delete';
import Create from './Create/Create'
import Move from './Move/Move';
import Rename from './Rename/Rename';
import GetFileProperties from './GetFileProperties/GetFileProperties';
import Zip from './Zip/Zip';
import Unzip from './Unzip/Unzip';
import { types } from './types';

//Enter the switch according to the incoming action names, it renders.
function Actions(action, showAlert, variables, setOpenVariable, automId) {
    switch (action.actionName) {
        case types.COPY: return <Copy action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.DELETE: return <Delete action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.CREATE: return <Create action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.MOVE: return <Move action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.RENAME: return <Rename action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.ZIP: return <Zip action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.UNZIP: return <Unzip action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        case types.GETFILEPROPERTIES: return <GetFileProperties action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        default: break;
    }
}
export default Actions;